import { useState } from "react";

export enum DestinationLinkDialogStep {
  INTEGRATION_STEP,
  CONNECT_DESTINATION_STEP,
  SUCCESS_STEP,
  ERROR_STEP,
}

const useDestinationLinkDialogStep = () => {
  const [step, setStep] = useState(DestinationLinkDialogStep.INTEGRATION_STEP);

  return { step, setStep };
};

export default useDestinationLinkDialogStep;
